module.exports = __webpack_public_path__ + "static/img/3.1f663bb2.png";